import { Module } from '../Module';
import { GetLanguagesRequest } from '../ServerApi/requests/GetLanguagesRequest';
import { ILanguage } from '../ServerApi/types/ILanguage';
import { ServerService } from '../services/ServerService';

export class Languages {

  public static $inject = ['$translate', 'ServerService'];

  constructor(private $translate: ng.translate.ITranslateService, private server: ServerService) {}

  public getAll(): ng.IPromise<ILanguage[]> {
    return this.server.sendRequest(new GetLanguagesRequest()).then(result => result.languages);
  }

  // a special value for the user language that indicates that we should use the server language
  public unspecifiedLanguage(): ILanguage {
    return {
      displayName: this.$translate.instant('unspecified'),
      language: null,
      locale: null
    };
  }

}

Module.instance().service('Languages', Languages);
